/**
 * Update the browser URL to reflect the current session without triggering
 * React Router re-render. This keeps the URL sharable/F5-able while avoiding
 * the layout flicker caused by React Router's location state change.
 *
 * Only applies when NOT embedded (full page mode). In embedded mode the host
 * page owns the URL and we must not touch it.
 */
export function syncChatUrl({ sessionId, isEmbedded, buildPath }) {
    if (isEmbedded || !sessionId) return;
    if (typeof window === 'undefined') return;
    const url = buildPath ? buildPath(`/chat/${sessionId}`) : `/chat/${sessionId}`;
    try {
        window.history.replaceState(null, '', url);
    } catch {
        // ignore silently; URL visual sync is best-effort
    }
}
